import { QueryMatchRule } from 'src/app/modules/core/store/models/filters.model';
import { QuickFilterConfiguration, QuickFilterSelection } from './quick-filter.model';
import { Document, DocumentsSet } from 'src/app/modules/core/store/models/document.model';
import { VisualizationLayerOptions } from './visualization-layer-options.model';

export interface Layer {
  uId?: string | null;
  folderUId?: string | null;
  name?: string | null;
  sortOrder?: number | null;
  createdOn?: string | null;
  updatedOn?: string | null;
  lastEditedByName?: string | null;
  lastEditedById?: string | null;
  isActive?: boolean;
  color?: string | null;
  type?: LayerTypes;
  isCustomIcon?: boolean;
  iconPath?: string | null;
  datasetUId?: string | null;
  displayOptions?: DisplayOptions | null;
  foreignDatasetDefinition?: any | null;
  rule?: QueryMatchRule | null;
  markerName?: string | null;
  markerSize?: string | null;
  customMarkerImage?: string | null;
  customMarkerImageHeight?: number | null;
  customMarkerImageWidth?: number | null;
  isAvailableInSiteWatch?: boolean;
  isEdited?: boolean;
}

export interface LayerState {
  documentCount?: number;
  isVisible?: boolean;
  isLoading?: boolean;
  documents?: DocumentsSet;
  isAnimated?: boolean;
  isError?: boolean;
}

export interface LayerQuickFilterSelections {
  [layerUId: string]: QuickFilterSelection;
}

export interface LayerDocumentsSet {
  [layerUId: string]: DocumentsSet;
}

export interface LayerDocumentUIdsSet {
  [layerUId: string]: string[];
}

export interface LayerDocuments {
  [layerUId: string]: Document[];
}

export interface LayerExtraGeoFields {
  layerUId: string;
  stepUId?: string;
  fieldNames: string[];
}

export interface StoreLayerDocumentsRequest {
  layerDocumentsSet: LayerDocumentsSet;
  shouldMergeDocuments: boolean;
}

export enum LayerTypes {
  Other = 0,
  Asset = 1,
  Alert = 2,
  Tile = 3,
  Image = 4,
  FloorPlan = 5,
  WeatherImagery = 6,
  Incident = 7,
  Visualization = 8,
  HorizonLocationIntelRatings = 9,
  MappedInAmenity = 97,
  MappedInCategory = 98,
  MappedInOfficer = 99
}

export interface DisplayOptions {
  pinClusteringMode?: ClusterPinModes;
  shapeOpacity?: number;
  imageSourceField?: string;
  minDrawZoom?: number;
  maxDrawZoom?: number;
  minLabelZoom?: number;
  maxClusterZoom?: number;
  shapeStrokeWidth?: number;
  renderLensMode?: RenderLensMode;
  maxItemsToRender?: number;
  zoomToFeatureLevel?: number;
  queryBufferM?: number;
  floorFilterSourceField: string;
  drawAsGeoJson?: boolean;
  geoJsonSourceField?: string;
  geoFieldsToDisplay?: string[];
  optionalGeoFieldsToDisplay?: string[];
  quickFilter?: QuickFilterConfiguration[];
  labelsVisible?: boolean;
  labelStyle?: {
    textColor?: string;
    backgroundColor?: string;
    borderWidth?: number;
    fontSize?: number;
    fontWeight?: number;
    borderColor?: string;
    borderRadius?: number;
    position?: 'top';
  };
  reloadOnUpdates?: boolean;
  weatherGeometryLevel?: GeometryRenderLevel;
  tileSize?: number | null;
  includeInNotifications?: boolean;
  notificationSound?: string;
  tileLayerZIndex?: number | null;
  popupsEnabled?: boolean;
  historyTrackEnabled?: boolean;
  visualizationLayerOptions?: VisualizationLayerOptions;
  strokeOpacity?: number;
  fillOpacity?: number;
  showInTimeline?: boolean;
  timelineFromField?: string;
  timelineToField?: string;
}

export enum RenderLensMode {
  default = 'default',
  viewport = 'viewport'
}

export enum ClusterPinModes {
  Never = 0,
  AcrossLayers = 1,
  WithinLayer = 2
}

export enum GeometryRenderLevel {
  none = 0,
  low = 1,
  medium = 2,
  high = 3
}
